<script lang="ts">
  import ArrowUpIcon from "$lib/icons/ArrowUpIcon.svelte";
  import type {IBalance, INetwork} from "$lib/interfaces/IBalance";
  import {createEventDispatcher, onMount} from "svelte";
  import {clickOutside} from "$lib/directives/clickOutside";

  const dispatch = createEventDispatcher();

  let isOpen = $state(false);

  interface Props {
    items?: any[];
    id?: string;
    selected: any;
    hasIcon?: boolean;
    selectedTitle?: string;
    formatLabel?: (item: any) => string;
  }

  let {
    items = [],
    id = '',
    selected = $bindable(),
    hasIcon = false,
    selectedTitle = 'name',
    formatLabel = null
  }: Props = $props();

  let dropdownRef: HTMLDivElement;

  function toggleDropdown() {
    isOpen = !isOpen;
  }

  function dispatchSelected(item: any) {
    selected = item;
    dispatch('selected', item);
    toggleDropdown();
  }

  function handleClickOutside(event: MouseEvent) {
    if (dropdownRef && !dropdownRef.contains(event.currentTarget as Node)) {
      isOpen = false;
    }
  }

  function getIconName(item: any) {
    // Use the selectedTitle property if it exists, otherwise fall back to 'name'
    const propertyValue = item[selectedTitle] || item.name;
    return propertyValue ? propertyValue.toLowerCase() : '';
  }

  function getDisplayText(item: any) {
    // Use formatLabel function if provided, otherwise use the selectedTitle property
    if (formatLabel && typeof formatLabel === 'function') {
      return formatLabel(item);
    }
    return item[selectedTitle] || '';
  }

  onMount(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  });
</script>

<div class="relative" use:clickOutside={() => isOpen = false} bind:this={dropdownRef}>
  <button on:click={() => toggleDropdown()} class="flex items-center bg-primary-dark pl-3.5 pr-2 py-2 rounded-full text-sm">
    {#if hasIcon && selected}
      <img src="/currencies/{getIconName(selected)}.png" class="w-6 mr-2" alt={getDisplayText(selected)}>
    {/if}
    {getDisplayText(selected)}
    <ArrowUpIcon />
  </button>
  <div class="{isOpen ? 'absolute' : 'hidden'} p-2 rounded-xl bg-primary-dark z-50 w-40 animate-fadeIn" {id}>
    {#if items && items.length > 0}
      {#each items as item}
        <button class="flex items-center py-2 px-3 hover:bg-primary-blue animate-fadeIn rounded-md w-full" on:click={() => dispatchSelected(item)}>
          {#if hasIcon}
            <img src="/currencies/{getIconName(item)}.png" class="w-6 mr-2" alt={getDisplayText(item)}>
          {/if}
          <span class="text-sm text-nowrap">{getDisplayText(item)}</span>
        </button>
      {/each}
    {:else}
      <div class="text-center text-white">Loading...</div>
    {/if}
  </div>
</div>

<style>
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .animate-fadeIn {
    animation: fadeIn 0.3s ease-in-out;
  }
</style>